import { useState } from 'react';
import { NestedMenuItemData, LinkBracket, LinkIfHref } from '@components';
import { addTrailingSlash } from '@utils';

const MenuItem: React.FC<{ item: NestedMenuItemData }> = ({ item }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {item.children && (
        <div className='flex'>
          <div className='relative ml-auto'>
            <HeaderDropdownMenu items={item.children} hidden={!open} />
          </div>
        </div>
      )}
      <LinkIfHref href={addTrailingSlash(item.href)}>
        <div
          className='flex cursor-pointer items-center gap-8 border-b border-secondary-light py-3 text-top-primary hover:text-primary'
          onClick={() => setOpen((prev) => !prev)}
        >
          {item.label}
          <LinkBracket className='ml-auto' />
        </div>
      </LinkIfHref>
    </>
  );
};

export const HeaderDropdownMenu: React.FC<{
  items: NestedMenuItemData[];
  hidden?: boolean;
  className?: string;
}> = ({ items, hidden, className }) => (
  <div
    className={`absolute top-1 z-10 w-96 rounded-lg bg-white p-6 font-bold shadow-md ${className}`}
    hidden={hidden}
  >
    {items.map((item) => (
      <MenuItem key={item.label} item={item} />
    ))}
  </div>
);
